<script>import { Fireworks } from 'fireworks-js';
let className = '';
export { className as class };
export let autostart = true;
export let style = '';
export let options = {};
let fireworks;
export function fireworksInstance() {
    return fireworks;
}
function setup(container, options) {
    fireworks = new Fireworks(container, options);
    if (autostart) {
        fireworks.start();
    }
    return {
        update(options) {
            fireworks.updateOptions(options);
        },
        destroy() {
            fireworks.stop();
        }
    };
}
</script>

<div
  use:setup={options}
  class={className}
  {style}
>
  <slot />
</div>
